<template>
  <div class="data-card">
    <div class="flex-row flex-align-center">
      <div class="label flex-1">{{ title }}</div>
      <template v-if="showSelect">
        <div class="fz-14 mr-16" v-if="showTime">统计时间: {{ statisticsTime }}</div>
        <div class="date-select">
          <div class="item" :class="{ active: index === timeIndex }" @click="selectTime(index, item.value)" v-for="(item, index) in timeList" :key="index">{{ item.label }}</div>
        </div>
      </template>
    </div>
    <div class="info-wrap">
      <div class="item" v-for="(item, index) in list" :key="index">
        <div class="num">{{ item.number }}<span class="fz-12 ml-4" v-if="item.second">秒</span></div>
        <div class="text">
          <span class="mr-4">{{ item.label }}</span>
          <el-tooltip :content="item.desc" v-if="item.desc">
            <i class="iconfont icon-a-help-circle-obangzhu-xian"></i>
          </el-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {calDate} from '@/utils/common';
import {format, startOfDay, endOfDay} from 'date-fns';
export default {
  name: 'dataCard',
  props: {
    title: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: _ => []
    },
    timeList: {
      type: Array,
      default: _ => [
        { value: 0, label: '今日' },
        { value: 1, label: '昨日' },
        { value: 7, label: '7天' },
        { value: 15, label: '15天' },
        { value: 30, label: '30天' },
        { value: 90, label: '90天' },
        { value: 180, label: '180天' }
      ]
    },
    showTime: {
      type: Boolean,
      default: true
    },
    showSelect: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      timeIndex: 0,
      statisticsTime: ''
    }
  },
  methods: {
    reset(index, value) {
      this.timeIndex = index
      if(this.showTime) return this.setTimeText(value)
    },
    setTimeText(value) {
      const today = new Date();
      const [start_time, end_time] = !value ? [startOfDay(today), endOfDay(today)] : calDate(value);
      const startTimeText = format(start_time, 'yyyy/MM/dd');
      const endTimeText = format(end_time, 'yyyy/MM/dd');
      this.statisticsTime = `${startTimeText}${this.timeIndex > 1 ? '-' + endTimeText : ''}`
      return {
        start_time: Math.trunc(start_time / 1000),
        end_time: Math.trunc(end_time / 1000)
      }
    },
    selectTime(index, value) {
      this.timeIndex = index
      if(!this.showTime) return this.$emit('submit', value)
      const { start_time, end_time } = this.setTimeText(value)
      this.$emit('submit', { start_time, end_time })
    }
  }
}
</script>

<style lang="less" scoped>
.data-card {
  border-bottom: 1px solid #eee;
  padding-bottom: 32px;
  .label {
    font-size: 16px;
    font-weight: bold;
  }
  .date-select {
    display: flex;
    align-items: center;
    border: 1px solid #eee;
    border-radius: 2px;
    font-size: 14px;
    .item {
      padding: 4px 12px;
      cursor: pointer;
      &.active {
        color: @color-primary;
      }
      &:nth-child(n+2) {
        border-left: 1px solid #eee;
      }
    }
  }
  .info-wrap {
    display: flex;
    flex-wrap: wrap;
    margin-top: 32px;
    padding-left: 16px;
    padding-right: 40px;
    .item {
      display: flex;
      flex-direction: column;
      width: 25%;
      .num {
        font-size: 24px;
        color: #333;
        font-weight: bold;
      }
      .text {
        font-size: 14px;
        color: #666;
        margin-top: 12px;
        display: flex;
        align-items: center;
      }
      &:nth-child(n+5) {
        margin-top: 40px;
      }
    }
  }
}
</style>
